import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanOnboardUser = (): boolean => {
  const [canOnboardUser, setCanOnboardUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const onboardAllPermission: Permission = {
    resource: 'users',
    action: 'onboard',
    scope: 'all',
  };

  const canCreateAll = useHasPermission(user, onboardAllPermission);

  React.useEffect(() => {
    setCanOnboardUser(canCreateAll);
  }, [user, canCreateAll]);

  return canOnboardUser;
};
